import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { Pagination } from "./Pagination";
import { QueryParamsEntities } from "./MainApp";

export class HubManifestTemporaryItem {
  hmtId = 0;
  hmtBagNo = "";
  hmtSttNo = "";
  hmtRefNo = "";
  hmtStts = 0;
  hmtPieces = 0;
  hmtGrossWeight = 0;
  hmtProductType = "";
  hmtScanStatus = 0;
  hmtErrorMessage = "";
  hmtDemNo = "";
  constructor(fields?: Partial<HubManifestTemporaryItem>) {
    Object.assign(this, fields);
  }
}
export class HubManifestTemporaryList {
  data: HubManifestTemporaryItem[] = [];
  pagination = new Pagination(1, 20);
  constructor(fields?: Partial<HubManifestTemporaryList>) {
    Object.assign(this, fields);
  }
}

export class InHubScanGenerate {
  hmtId = 0;
  hmtSttNo = "";
  hmtBagNo = "";
  hmtRefNo = "";
  hmtDemNo = "";
  hmtProductType = "";
  hmtPiece = 0;
  hmtGrossWeight = 0;
  hmtScanStatus = "";
  hmtDemOrBagStatus = "";

  constructor(fields?: Partial<InHubScanGenerate>) {
    Object.assign(this, fields);
  }
}

export class InHubScanGenerateList {
  data: InHubScanGenerate[] = [];
  success = false;
  message = "";
  constructor(fields?: Partial<InHubScanGenerateList>) {
    Object.assign(this, fields);
  }
}

export class InHubScanFailed {
  sttOrBag = "";
  errorMessage = "";

  constructor(fields?: Partial<InHubScanFailed>) {
    Object.assign(this, fields);
  }
}

export class InHubScanTemporaryListRequest {
  hmtHubId = "0";
  hmtIsInHub = true;
  hmtScanStatus = "success";
  q = "";
  page = 1;
  limit = 20;

  constructor(fields?: Partial<InHubScanTemporaryListRequest>) {
    Object.assign(this, fields);
    this.hmtHubId = getHubData().hubId || "0";
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}
export class ResponsePayload {
  hubId = "";
  status = "";
  plateNumber = "";
  success = true;
  code = 0;
  message = "";
  data: any = null;
  constructor(fields?: Partial<ResponsePayload>) {
    Object.assign(this, fields);
  }
}

export class HubInOutManifest {
  hmId = 0;
  hmNo = "";
  hmStts = 0;
  hmSttPieces = 0;
  hmSttGrossWeights = 100;
  hmCreatedAt = "";
  hmCreatedByName = "";
  hmCreatedByRole = "";
  hmPlateNumber = "";
  hmHubDestinationName = "";

  constructor(fields?: Partial<HubInOutManifest>) {
    Object.assign(this, fields);
  }
}
export class HubManifestDetail {
  hmId = 0;
  hmNo = "";
  hmStts = 0;
  hmSttPieces = 0;
  hmSttGrossWeights = 0;
  hmCreatedAt = "";
  hmCreatedByName = "";
  hmCreatedByRole = "";
  hmPlateNumber = "";
  hmHubDestinationName = "";
  hmHubName = "";
  stts: HubManifestDetailItem[] = [];

  constructor(fields?: Partial<HubManifestDetail>) {
    Object.assign(this, fields);
  }
}


export class HubInOutManifestRequest {
  hmNo = "0";
  startDate = "";
  endDate = "";
  createdType = "";
  accountId = 0;
  page = 1;
  limit = 10;
  isInHub = false;
  hmHubId = 0;

  constructor(fields?: Partial<HubInOutManifestRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class HubInOutManifestEntities {
  pagination: Pagination;
  data: HubInOutManifest[];

  constructor(pagination: Pagination, data: HubInOutManifest[]) {
    this.pagination = pagination;
    this.data = data;
  }
}
export class HubManifestDetailItem {
  hmdId = 0;
  hmdDemNo = "";
  hmdBagNo = "";
  hmdSttNo = "";
  hmdRefNo = "";
  hmdPieces = 0;
  hmdGrossWeight = 0;
  hmdProductType = "";
  hmdDestinationDistrictName = "";
  constructor(fields?: Partial<HubManifestDetailItem>) {
    Object.assign(this, fields);
  }
}

export class HubInOutManifestExcelRequest {
  id?: number;
  type?: string;

  constructor(fields?: Partial<HubInOutManifestExcelRequest>) {
    Object.assign(this, fields);
  }
}

export class HubInOutManifestExcel {
  id = 0;
  type = "";

  constructor(fields?: Partial<HubInOutManifestExcel>) {
    Object.assign(this, fields);
  }
}
